import get from 'lodash.get';

import { selectPasswordReset } from '../../../../redux/auth/passwordReset/selectors';
import { createDeepEqualSelector } from '../../../../redux/utils/selectors';

export const selectIsLoading = createDeepEqualSelector(selectPasswordReset, (emailActivation) =>
  get(emailActivation, 'loading', false),
);

export const selectError = createDeepEqualSelector(selectPasswordReset, (emailActivation) =>
  get(emailActivation, 'err', false),
);

export const selectErrorMessage = createDeepEqualSelector(selectPasswordReset, (emailActivation) =>
  get(emailActivation, 'errMsg', 'Error'),
);
